import ES from './es';
import EN from './en';

const common = {
    ES,
    EN
};

export default common;
